/**
 * @generated SignedSource<<6061cf1a789a1535f08f4e89aaac625d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionQueryDeleteMutation$variables = {
  id: string;
};
export type processDefinitionQueryDeleteMutation$data = {
  readonly deleteProcessDefinition: boolean | null | undefined;
};
export type processDefinitionQueryDeleteMutation = {
  response: processDefinitionQueryDeleteMutation$data;
  variables: processDefinitionQueryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProcessDefinition",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2098e24cd0af4154a54be3ee1579c91",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionQueryDeleteMutation(\n  $id: ID!\n) {\n  deleteProcessDefinition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "548a6ff9cf0644cbee59e6db57f51fa3";

export default node;
